/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Message_LabelInputs */



/**
* | output |
* | --- |
* | "Message" |
*
* @param {Snapshot_History_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_message_label = /** @type {((inputs?: Snapshot_History_Message_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Message_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Message")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachricht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Messaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сообщение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mensaje")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メッセージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संदेश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mensagem")
	return /** @type {LocalizedString} */ ("Message")
});